// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Skeleton__container-b42f8e {
  --skeleton-loader-width: 50px;
  --skeleton-loader-animation-duration: 1600ms;
  --skeleton-loader-animation-iteration-count: infinite;
  --skeleton-loader-animation-timing-function: ease;
  display: inline-block;
  border-radius: 8px;
  background-color: var(--base-20);
  position: relative;
  overflow: hidden;
  max-width: 100%;
}

.Skeleton__animated-bf3308:before {
  content: "";
  position: absolute;
  top: 0;
  left: var(--skeleton-loader-start-position);
  width: var(--skeleton-loader-width);
  height: 100%;
  background-image: linear-gradient(90deg, transparent 0, var(--base-30) 45%, var(--base-30) 55%, transparent);
  animation-name: Skeleton__loading-f27445;
  animation-timing-function: var(--skeleton-loader-animation-timing-function);
  animation-iteration-count: var(--skeleton-loader-animation-iteration-count);
  animation-duration: var(--skeleton-loader-animation-duration);
}

@keyframes Skeleton__loading-f27445 {
  from {
    left: var(--skeleton-loader-start-position);
  }
  to {
    left: var(--skeleton-loader-end-position);
  }
}`, "",{"version":3,"sources":["webpack://./../../packages/ui-kit/src/Skeleton/Skeleton.styles.m.css"],"names":[],"mappings":"AAAA;EACE,6BAAA;EACA,4CAAA;EACA,qDAAA;EACA,iDAAA;EAEA,qBAAA;EACA,kBAAA;EACA,gCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;AAAF;;AAGA;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,2CAAA;EACA,mCAAA;EACA,YAAA;EACA,4GAAA;EAOA,wCAAA;EACA,2EAAA;EACA,2EAAA;EACA,6DAAA;AANF;;AASA;EACE;IACE,2CAAA;EANF;EAQA;IACE,yCAAA;EANF;AACF","sourcesContent":[".container {\n  --skeleton-loader-width: 50px;\n  --skeleton-loader-animation-duration: 1600ms;\n  --skeleton-loader-animation-iteration-count: infinite;\n  --skeleton-loader-animation-timing-function: ease;\n\n  display: inline-block;\n  border-radius: 8px;\n  background-color: var(--base-20);\n  position: relative;\n  overflow: hidden;\n  max-width: 100%;\n}\n\n.animated:before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: var(--skeleton-loader-start-position);\n  width: var(--skeleton-loader-width);\n  height: 100%;\n  background-image: linear-gradient(\n    90deg,\n    transparent 0,\n    var(--base-30) 45%,\n    var(--base-30) 55%,\n    transparent\n  );\n  animation-name: loading;\n  animation-timing-function: var(--skeleton-loader-animation-timing-function);\n  animation-iteration-count: var(--skeleton-loader-animation-iteration-count);\n  animation-duration: var(--skeleton-loader-animation-duration);\n}\n\n@keyframes loading {\n  from {\n    left: var(--skeleton-loader-start-position);\n  }\n  to {\n    left: var(--skeleton-loader-end-position);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Skeleton__container-b42f8e`,
	"animated": `Skeleton__animated-bf3308`,
	"loading": `Skeleton__loading-f27445`
};
module.exports = ___CSS_LOADER_EXPORT___;
